import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `pto-topic`);
        return response;
    } catch (e) { }
}

export async function PTOAdd(newDetails: any) {
    try {
        const response = await apiPost('core', `pto-topic`, newDetails);
        return response;
    } catch (e) { }
}

export async function PTOUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `pto-topic/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removePTO(id: any) {
    try {

        return await apiDelete('core', `pto-topic/${id}`);
    } catch (e) { }
}


export async function PTOListUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `pto-list/${id}`, newDetails);
        return response;
    } catch (e) { }
}